import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'simple-fullwidth-2-normal-scroll',
    templateUrl  : './fullwidth-2.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SimpleFullwidth2NormalScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
